<template>
  <div>
    <container @drop="onDrop" style="padding-bottom: 80px;">
      <menu-item-list-item
        :active="menuItemSelected !== null && menuItemSelected.id === item.id"
        @onClickItemMenu="clickMenuItemHandler"
        v-for="(item, index) in items"
        :item="item"
        :menuId="menuId"
        :key="index">
      </menu-item-list-item>
    </container>
  </div>
</template>

<script>
import MenuItemListItem from "@views/admin/backoffice-nav-management/MenuItemListItem.vue";
import {NavigationService} from "@/models/Menu/NavigationService";
import { Container } from "vue-smooth-dnd";

export default {
  name: "MenuItemList",
  components: {MenuItemListItem, Container},
  props: ['items', 'menuId', 'menuItemSelected'],
  methods: {
    clickMenuItemHandler(e) {
      this.$emit('onClickItemMenu', e)
    },
    onDrop(dropResult) {
      this.items = this.applyDrag(this.items, dropResult);
      this.saveSortingItems();
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },
    async saveSortingItems() {
      this.items.forEach((item, index) =>  {
        item.order = index + 1;
      })

      this.$vs.loading();

      try {
        await NavigationService.changeSort(
            this.menuId,
            this.items.map((item) => {
              return {
                menuItemId: item.id,
                order: item.order
              }
            })
        );
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
